import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Claim } from '@wsphere/warranties/domain';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-claim-totals-card',
  templateUrl: './claim-totals-card.component.html',
  standalone: false,
})
export class ClaimTotalsCardComponent {
  /** Hidden on old claims that have no charges. */
  @Input() claim: Claim.Model | null = null;

  get totals() {
    return this.claim?.totals ?? null;
  }

  formatAmount(amount: number) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: this.totals?.currency ?? 'USD' }).format(
      amount / 100
    );
  }
}
